import { Component, OnInit } from '@angular/core';
import { AuthService } from '../_services/auth.service';
import { SpinnerService } from '../_core/spinner/spinner.service';
import { Router } from '@angular/router';
import { UserDataService } from '../_services/user-data.service';
import { UserDetailsDataForm } from '../_models/user-details-data-form';
import { MatTableDataSource } from '@angular/material';

@Component({
  selector: 'app-dashboard-admin',
  templateUrl: './dashboard-admin.component.html',
  styleUrls: ['./dashboard-admin.component.css']
})
export class DashboardAdminComponent implements OnInit {

  userDetailsDataFormList: UserDetailsDataForm[] = [];
  userDetailsDataSource = new MatTableDataSource<UserDetailsDataForm>();
  displayedColumns = ['serialNo', 'fullName', 'userName', 'mobileNo', 'noProject'];
  // Doughnut
  pieChartLabels: string[] = ['Toltal User Count', 'Users In Learning Module', 'Users In Doing Module'];
  pieChartData: Number[] = [];
  pieChartType: string = 'doughnut';
  pieChartColor: Array<any> = [{
    backgroundColor: ['#3879e2', '#d62261', '#55d622'],
    borderColor: ['rgba(135,206,250,1)', 'rgba(106,90,205,1)', 'rgba(148,159,177,1)']
  }];

  constructor(
    private authService: AuthService,
    private spinnerService: SpinnerService,
    private router: Router,
    private userDataService: UserDataService
  ) {
  }

  ngOnInit() {
    this.getAllUserListById()
    this.userdCounts();
  }

  applyFilter(filterValue: string) {
    this.userDetailsDataSource.filter = filterValue.trim().toLowerCase();
  }

  public logoutCall() {
    // Show Spinner
    // this.spinnerService.show();
    this.authService.logout();
  }

  getAllUserListById() {
    this.userDataService.getUserList().subscribe(
      resp => {
        this.userDetailsDataFormList = resp as UserDetailsDataForm[];
        this.userDetailsDataSource = new MatTableDataSource<UserDetailsDataForm>(this.userDetailsDataFormList);
      })
  }

  userdCounts() {
    this.userDataService.getUserCount().subscribe(
      resp => {
        let countRespString = JSON.stringify(resp)
        let countResp = JSON.parse(countRespString);
        this.pieChartData.push(countResp.totalUserCount, countResp.learningCompletedUserCount, countResp.doingCompletedUserCount)
      })
  }



  // events
  public chartClicked(e: any): void {
    console.log(e);
  }

  public chartHovered(e: any): void {
    console.log(e);
  }

}
